module.exports = __webpack_public_path__ + "img/ethereum.5f79a72d.png";